// extracted by mini-css-extract-plugin
var _1 = "SpinnerStyles-module__lds-spinner___LP8Gk";
var _2 = "SpinnerStyles-module__lds-spinner___LP8Gk";
export { _1 as "lds-spinner", _2 as "ldsSpinner" }
